<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div id="usersDetail" class="container-fluid">
  <fieldset>
    <legend>
      <div class="row">
        <span class="col-md-6 m-auto">
          <div>Partners</div>
        </span>
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-primary float-right"
            *ngIf="isMerchantActive()"
            (click)="openModal(editType.add, 'Add')"
          >
            <span>
              <fa-icon [icon]="faPlus"></fa-icon>
            </span>
            Add Partner
          </button>
        </div>
      </div>
    </legend>
  </fieldset>

  <div>
    <table
      class="table table-striped table-hover table-condensed"
      *ngIf="partners && partners.length > 0"
    >
      <thead>
        <tr>
          <th>Partner ID</th>
          <th>Username</th>
          <th>Password (click to show)</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let partner of partners; let indexOfElement = index">
          <td>
            {{ partner.id }}
          </td>
          <td>
            {{ partner.username }}
          </td>
          <td>
            <span *ngIf="!partner.showPassword" (click)="showPassword(partner)"
              >Click to show</span
            >
            <span
              *ngIf="partner.showPassword"
              (click)="showPassword(partner)"
              >{{ partner.password }}</span
            >
          </td>
          <td>
            <div class="float-right">
              <button
                class="btn btn-primary btn-xs mr-1"
                *ngIf="isMerchantActive()"
                (click)="
                  openModal(editType.edit, 'Edit', partner, indexOfElement)
                "
              >
                <span>
                  <fa-icon [icon]="faEditPencil"></fa-icon>
                </span>
                Edit
              </button>
              <button
                class="btn btn-primary btn-xs mr-1"
                *ngIf="isMerchantActive()"
                (click)="
                  openModal(
                    editType.resetPassword,
                    'Reset Password',
                    partner,
                    indexOfElement
                  )
                "
              >
                <span>
                  <fa-icon [icon]="faLock"></fa-icon>
                </span>
                Reset Password
              </button>
              <button
                class="btn btn-danger btn-xs"
                (click)="
                  openModal(editType.remove, 'Delete', partner, indexOfElement)
                "
              >
                <span class="oi oi-x"></span>
                Delete
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
